/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService
 */

/**
 *  Fields must be in VaasPayloadPropertyIF first and backfilled into the vector db.
 *  Fields must be Optional.
 */

export const searchPropertiesRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'searchProperties',
  auth: 'app',
  fingerprint: 'W8uOIBDZsMKFTZ-LB2RBLcUUrF_uj9vp'
};
export const searchPropertiesWithPagingRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'searchPropertiesWithPaging',
  auth: 'app',
  fingerprint: '2NHO7C8vb_cq_SsZnZIFXcUUrF_uj9vp'
};
export const searchPropertiesWithRankingDataRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'searchPropertiesWithRankingData',
  auth: 'app',
  fingerprint: 'VJqasoJ7RNOHTJmOEcMeEMUUrF_uj9vp'
};
export const searchPropertiesRerankedRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'searchPropertiesReranked',
  auth: 'app',
  fingerprint: 'NG6I9EXkoOO528N9ONmptsUUrF_uj9vp'
};
export const searchPropertyRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'searchProperty',
  auth: 'app',
  fingerprint: 'G7-MLmcv0CyTlAZ0CFBD9sUUrF_uj9vp'
};
export const searchPropertyWithValuesRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'searchPropertyWithValues',
  auth: 'app',
  fingerprint: 'RBqfvNHvkgSh5k5_Vb102MUUrF_uj9vp'
};
export const recordPropertyClickedEventRpc = {
  serviceName: 'com.hubspot.nlp.crm.search.rpc.propertysearch.NlpPropertySearchService',
  rpcName: 'recordPropertyClickedEvent',
  auth: 'app',
  fingerprint: '-eAUglnUcnVjrY6IsYH1T8UUrF_uj9vp'
};